module.exports = __webpack_public_path__ + "img/HKD.5cb7cdb8.svg";